import React, { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

const LABELS = { tasks: "open tasks", people: "assigned people", opportunities: "active opportunities", enrollments: "active enrollments", projects: "projects owned",
  support_assignments: "support assignments (flagged for reassignment)", future_meetings: "future meetings (kept — review)", events_organized: "future events organized",
  scheduling_pages: "scheduling pages (closed)", memberships: "group memberships (ended, kept as history)" };

export function OffboardDialog({ user, users, onClose, onDone }) {
  const [pv, setPv] = useState(null);
  const [to, setTo] = useState("");
  const [reason, setReason] = useState("");
  useEffect(() => { api.get(`/users/${user.id}/offboard/preview`).then((r) => setPv(r.data)).catch((e) => { toast.error(apiError(e)); onClose(); }); }, [user.id, onClose]);
  const go = async () => {
    try { const { data } = await api.post(`/users/${user.id}/offboard`, { successor_user_id: to, reason }); toast.success("User offboarded"); onDone(data.summary); }
    catch (e) { toast.error(apiError(e)); }
  };
  const successors = users.filter((u) => u.id !== user.id && u.status === "active" && (u.memberships || []).some((m) => !["candidate", "referral_partner", "agent", "agent_staff", "external_recruiter"].includes(m.role)));
  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="bg-white max-w-lg" data-testid="offboard-dialog">
        <DialogHeader><DialogTitle>Offboard {user.name}?</DialogTitle></DialogHeader>
        {pv && <div className="text-sm space-y-2">
          <p className="text-xs text-slate-500">Disables sign-in, ends sessions and View As, disconnects Microsoft 365 and stops sync, closes scheduling pages and clears report delivery. All history and attribution are kept.</p>
          <ul className="text-xs text-slate-600 grid grid-cols-2 gap-x-3" data-testid="offboard-counts">
            {Object.entries(LABELS).map(([k, l]) => <li key={k}><b>{pv.counts[k]}</b> {l}</li>)}
            <li><b>{pv.counts.microsoft_connected ? "Yes" : "No"}</b> Microsoft connected</li>
          </ul>
          <label className="block text-xs font-medium">Hand open work to *
            <select className="mt-1 w-full border rounded-md h-9 px-2 text-sm" value={to} onChange={(e) => setTo(e.target.value)} data-testid="offboard-successor">
              <option value="">Choose a staff member…</option>{successors.map((u) => <option key={u.id} value={u.id}>{u.name}{u.email ? ` (${u.email})` : ""}</option>)}
            </select></label>
          <Textarea placeholder="Reason (resigned, terminated…) *" value={reason} onChange={(e) => setReason(e.target.value)} data-testid="offboard-reason" />
        </div>}
        <DialogFooter><Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button className="bg-rose-600 hover:bg-rose-700" disabled={!to || !reason.trim()} onClick={go} data-testid="offboard-confirm">Offboard User</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
